// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__FMb-i","intIcon":"intIcon__lNcLu"};